// src/pages/Home/Home.js
import React from "react";
import "./Home.css";
import { FaArrowRightLong } from "react-icons/fa6";
import Slider from "../../components/Slider";
import SplitText from "../../components/SplitText";
import { motion } from "framer-motion";

const Home = () => {
  return (
    <div className="home-container">

      {/* Background Video Section with YouTube iframe */}
      <section className="hero-section">
        <div className="hero-video-overlay">
          {/* <iframe
            className="background-video"
            src="https://www.youtube.com/embed/UGa6jC27_Bc?autoplay=1&loop=1&mute=1&playlist=UGa6jC27_Bc&controls=0&showinfo=0&modestbranding=1&iv_load_policy=3&fs=0"
            frameBorder="0"
            allow="autoplay; encrypted-media"
            allowFullScreen
            title="Background Video"
            
          /> */}
          <video autoPlay muted loop src="/banner.mp4"></video>
          <div className="overlayer">
            <div className="hero-content">
              <SplitText
                text="Welcome to Truth Experienced"
                className="text-2xl font-semibold text-center"
                delay={40}
                animationFrom={{
                  opacity: 0,
                  transform: "translate3d(0,50px,0)",
                }}
                animationTo={{ opacity: 1, transform: "translate3d(0,0,0)" }}
                easing="easeOutCubic"
                threshold={0.2}
                rootMargin="-50px"
              />

              <motion.p
                initial={{ y: 100, opacity: 0 }} // Start from top
                animate={{ y: 0, opacity: 1 }} // Slide down to its position
                transition={{ duration: 0.6, delay: 1.2, ease: "easeOut" }}
              >
                Explore enlightening experiences, videos, blogs, and more...
              </motion.p>
              <motion.button
                initial={{ y: 100, opacity: 0 }} // Start from top
                animate={{ y: 0, opacity: 1 }} // Slide down to its position
                transition={{ duration: 0.6, delay: 1.3, ease: "easeOut" }}
              >
                <a href="/posts">
                  {" "}
                  Explore now <FaArrowRightLong color="white" />
                </a>
              </motion.button>
            </div>
          </div>
        </div>
      </section>
      <motion.div
        className="my-5 text-center slider-sec py-3"
        initial={{ y: 50, opacity: 0 }}
        whileInView={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        viewport={{ once: true, amount: 0.2 }}
      >
        <h3>Path to Spiritual Enlightenment</h3>
        <p>Explore wisdom, meditation, and mindfulness for personal growth.</p>

        {/* Delay for Slider */}
        <motion.div
          initial={{ opacity: 0, y: 100 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 1, ease: "easeOut" }}
          viewport={{ once: true }}
        >
          <Slider />
        </motion.div>
      </motion.div>

      <div className="book-sec mb-5 position-relative">
        <motion.div
          initial={{ y: 50, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          transition={{ duration: 1, ease: "easeOut" }}
          viewport={{ once: true, amount: 0.2 }}
          className="book-container "
        >
          <div className="row h-100">
            <div className="col-12 col-md-4 p-0">
              <div className="left-side d-none d-md-block">
                <img
                  src="https://i1.sndcdn.com/artworks-B0zrd2LSVVD1nhdS-GbJOyg-t500x500.jpg"
                  alt=""
                />
                <div className="book-overlayer">{/* <h3>Education</h3> */}</div>
              </div>
            </div>
            <div className="col-12 col-md-4 p-0">
              <div className="center">
                <img
                  src="https://i.pinimg.com/736x/b5/0f/69/b50f69e145f755d0f9b73b91fa5aa402.jpg"
                  alt=""
                />
                <div className="book-overlayer">
                  <div className="content">
                    <span>Coming Soon</span>
                    <h2>Shivoham</h2>
                    <p>
                      A transformative journey of self-realization and spiritual
                      awakening. Stay tuned for the release of "Shivoham"!
                    </p>
                    <button className="btn-learn-more">Learn More</button>
                  </div>
                  <h3>Spiritual</h3>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-4 p-0">
              <div className="left-side right-sec d-none d-md-block">
                <img
                  src="https://i.pinimg.com/originals/fa/10/6b/fa106bc50c1c364ce84eb9e0171a782e.jpg"
                  alt=""
                />
                <div className="book-overlayer">
                  {/* <h3>Rural Upliftment</h3> */}
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
      {/* Videos Section */}
      {/* <section className="feature-section" id="videos">
        <div className="feature-background-video">
          <iframe
            className="background-video"
            src="https://www.youtube.com/embed/2on_6anJe4c?autoplay=1&loop=1&mute=1&playlist=2on_6anJe4c&controls=0&showinfo=0&modestbranding=1&iv_load_policy=3&fs=0"
            frameBorder="0"
            allow="autoplay; encrypted-media"
            allowFullScreen
            title="Background Video"
          />
          <div className="feature-content">
            <h2>Videos</h2>
            <p>Explore videos on enlightenment and self-discovery.</p>
          </div>
        </div>
      </section> */}

      {/* Shorts Section 1 (smaller video) */}
      {/* <section className="shorts-section">
        <div className="shorts-video-overlay">
          <iframe
            className="background-video"
            src="https://www.youtube.com/embed/JortEjpDFW8?autoplay=1&loop=1&mute=1&playlist=JortEjpDFW8&controls=0&showinfo=0&modestbranding=1&iv_load_policy=3&fs=0"
            frameBorder="0"
            allow="autoplay; encrypted-media"
            allowFullScreen
            title="YouTube Short 1"
          />
          <div className="shorts-content">
            <h3>YouTube Short 1</h3>
          </div>
        </div>
      </section>

      {/* Shorts Section 2 (smaller video) */}
      {/*<section className="shorts-section">
        <div className="shorts-video-overlay">
          <iframe
            className="background-video"
            src="https://www.youtube.com/embed/xW7P5wXLw2Y?autoplay=1&loop=1&mute=1&playlist=xW7P5wXLw2Y&controls=0&showinfo=0&modestbranding=1&iv_load_policy=3&fs=0"
            frameBorder="0"
            allow="autoplay; encrypted-media"
            allowFullScreen
            title="YouTube Short 2"
          />
          <div className="shorts-content">
            <h3>YouTube Short 2</h3>
          </div>
        </div>
      </section> */}

      {/* Upcoming Section: Shivoham Book */}
      {/* <section className="upcoming-section">
        <div className="upcoming-overlay">
          <iframe
            className="background-video"
            src="https://www.youtube.com/embed/UGa6jC27_Bc?autoplay=1&loop=1&mute=1&playlist=UGa6jC27_Bc&controls=0&showinfo=0&modestbranding=1&iv_load_policy=3&fs=0"
            frameBorder="0"
            allow="autoplay; encrypted-media"
            allowFullScreen
            title="Background Video"
          />
          <div className="upcoming-content">
            <h2>Coming Soon: Shivoham</h2>
            <p>
              A transformative journey of self-realization and spiritual
              awakening. Stay tuned for the release of "Shivoham"!
            </p>
            <button className="btn-learn-more">Learn More</button>
          </div>
        </div>
      </section> */}
    </div>
  );
};

export default Home;
